import _ from 'lodash'
import { FETCH_PRODUCT_CLIENTS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PRODUCT_CLIENTS:
      return action.payload
    default:
      return state
  }
}
